import {useIntl} from 'react-intl';
import {useDispatch} from 'react-redux';
import {useKeycloak} from '@react-keycloak/web';
import {PhoneHQButton, PhoneHQGlyph} from 'ch3-ui-lib';
import type {AccountBlockedReason} from '../../services/accountAccessState';
import {performLogout} from '../../services/performLogout';
import {useMatrixContext} from '../../providers/MatrixProvider';

const MESSAGE_IDS: Record<AccountBlockedReason, {title: string; message: string}> = {
    ACCOUNT_LOCKED: {
        title: 'account-blocked.locked.title',
        message: 'account-blocked.locked.message',
    },
    TENANT_SUSPENDED: {
        title: 'account-blocked.suspended.title',
        message: 'account-blocked.suspended.message',
    },
};

export function AccountBlockedNotice({reason}: {reason: AccountBlockedReason}) {
    const intl = useIntl();
    const dispatch = useDispatch();
    const {keycloak} = useKeycloak();
    const {logout} = useMatrixContext();
    const ids = MESSAGE_IDS[reason];

    const handleLogout = () => performLogout({dispatch, matrixLogout: logout, keycloak});

    return (
        <div
            role="alert"
            data-testid="account-blocked-notice"
            className="flex min-h-screen flex-col items-center justify-center px-4 text-center"
        >
            <span className="inline-flex size-16 shrink-0 items-center justify-center rounded-full bg-danger-tint text-danger-ink"><PhoneHQGlyph name="lock" size={32}/></span>
            <h6 className="mt-6 font-bold">{intl.formatMessage({id: ids.title})}</h6>
            <div className="mt-4 text-base">{intl.formatMessage({id: ids.message})}</div>
            <div className="mt-6 flex justify-center">
                <PhoneHQButton onClick={handleLogout}>{intl.formatMessage({id: 'account-blocked.logout'})}</PhoneHQButton>
            </div>
        </div>
    );
}
